import React from "react";
import Navbar from "./Navbar";
import Helmet from "react-helmet";
import "../styles/global.css";

export default function Layout({ children }) {
  return (
    <div className="layout" id="layoutPoint">
      <Helmet>
        <meta
          name="keywords"
          content="Luxera's Map, Grand Archive, Grand Archive TCG, luxera, luxeras map, tcg, ccg, trading card game, tournament, article, anime, card, competitive card game"
        />
      </Helmet>
      <Navbar />
      <div className="content">{children}</div>
      <footer>
        <p>
          Luxera's Map is a fan-made website. Grand Archive and all official
          assets are owned by Weebs of the Shore.
        </p>
      </footer>
    </div>
  );
}
